import { createFileRoute } from '@tanstack/react-router'
import { BrandCampaignLanding, brandCampaignHead, loadBrandCampaign } from '../components/BrandCampaignLanding'
import { getBrandCampaign } from '../data/brandCampaigns'

const campaign = getBrandCampaign('kaos-kaki-tuyaya')!
export const Route = createFileRoute('/kaos-kaki-tuyaya')({ loader: () => loadBrandCampaign(campaign), head: () => brandCampaignHead(campaign), component: Page })
function Page() { return <BrandCampaignLanding data={{ ...Route.useLoaderData(), campaign }} /> }
